export default __webpack_public_path__ + "static/media/doodle-img.bd65e894.png";